export default function () {
    let created = false;

    const producers = document.querySelector(".producers-menu > ul");
    const container = document.querySelector("#producers-top");
    const trigger = document.querySelector(".producers-trigger");

    if (!producers || !container || !trigger)
        return;

    if (!producers.querySelector('li.t1')) {
        container.querySelector('#producers-tree').remove();
        return;
    }

    ['mouseenter', 'focus', 'touchstart'].forEach(eventType => {
        trigger.addEventListener(eventType, createMenu);
    });

    function createMenu() {
        if (created)
            return;

        container.querySelector('nav ul').innerHTML = producers.innerHTML;

        container.querySelectorAll('.t1').forEach(child => {
            child.removeAttribute('class');
        });

        created = true;
    }
}